import api from './api';

export const getProductRecommendationsApi = async (limit = 12) => {
  const res = await api.get("/api/v1/products/recommendations", {
    params: { limit },
    skipAuth: true
  });
  return res.data;
};

export const getProductByIdApi = async (id) => {
  const res = await api.get(`/api/v1/products/${id}`, {
    skipAuth: true
  });
  return res.data;
};

export const getWeeklyBestSellersApi = async (limit = 10) => {
  const res = await api.get("/api/v1/products/weekly-best-sellers", {
    params: { limit },
    skipAuth: true,
  });
  return res.data;
};

export const getCommunityProductsApi = async (limit = 8) => {
  const res = await api.get("/api/v1/products/community", {
    params: { limit },
    skipAuth: true,
  });
  return res.data;
};

export const searchProductsApi = async (q, limit = 8) => {
  const res = await api.get("/api/v1/products", {
    params: { q, limit },
    skipAuth: true
  });
  return res.data?.data || [];
};

export const trackProductViewApi = async (productId) => {
  const res = await api.post(`/api/v1/products/${productId}/view`, {}, {
    skipAuth: true
  });
  return res.data;
};
